import { useContext } from 'react';
import { AppContext } from '../app/index';

function useAppContext() {
  return useContext(AppContext);
}

export default useAppContext;
